import { Card, inputBaseClasses, styled, TextField, Typography } from '@mui/material';
import { formHelperTextClasses } from '@mui/material/FormHelperText';
import { BORDER_RADIUS_3XL, BORDER_RADIUS_XL, COLOR_BG_BLACK_2, COLOR_RED, COLOR_STROKE, COLOR_WH } from 'shared';

export const BackgroundCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '650px',
  margin: '0 auto',
  padding: theme.spacing(3),
  borderRadius: BORDER_RADIUS_3XL,

  [theme.breakpoints.down('sm')]: {
    borderRadius: BORDER_RADIUS_XL,
    padding: theme.spacing(3, 2),
  },
}));

export const ProgressLabel = styled(Typography)(() => ({
  position: 'absolute',
  inset: '50% 50% auto auto',
  transform: 'translate(50%, -50%)',

  color: COLOR_BG_BLACK_2,
  fontWeight: 500,
}));

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== '$error',
})<{ $error?: boolean }>(({ $error }) => ({
  ...($error && {
    [`& .${formHelperTextClasses.root}`]: {
      position: 'absolute',
      top: 'calc(100% + 4px)',
      left: 0,
      margin: 0,
      padding: '8px',
      borderRadius: 4,
      backgroundColor: COLOR_RED,
      lineHeight: '16px',
      color: `${COLOR_WH} !important`,
      opacity: 1,
    },
    [`& > .${inputBaseClasses.root}`]: {
      borderColor: `${COLOR_RED} !important`,
    },
  }),
}));

export const AmountStyledTextField = styled(StyledTextField)(({ $error }) => ({
  position: 'relative',
  [`& > .${inputBaseClasses.root}`]: {
    borderColor: COLOR_STROKE,
    padding: '16px 16px 16px 24px',
    borderRadius: '14px',
    height: 56,

    [`& > .${inputBaseClasses.input}::placeholder`]: {
      fontSize: '20px',
      opacity: 1,
    },

    [`& > .${inputBaseClasses.input}`]: {
      lineHeight: '28px',
      fontSize: 20,
    },
  },
}));
